// Fallback breeds for variants without parentheses
const BREED_FALLBACKS = {
  'poodle': 'poodle__standard',
  'bulldog': 'bulldog__american'
};

/**
 * Convert breed name to CDN filename slug
 */
function getBreedSlug(breed) {
  if (!breed) return '';
  const lowerBreed = breed.toLowerCase();
  // Check if has parentheses variant like "Fox Terrier (smooth)"
  const parenMatch = lowerBreed.match(/^(.+?)\s*\((.+?)\)$/);
  if (parenMatch) {
    const base = parenMatch[1].trim().replace(/['']/g, '_').replace(/\s+/g, '_');
    const variant = parenMatch[2].trim().replace(/['']/g, '_').replace(/\s+/g, '_');
    return `${base}__${variant}`;
  }
  // Check for fallback (breeds that need a default variant)
  const simpleSlug = lowerBreed.replace(/['']/g, '_').replace(/\s+/g, '_');
  if (BREED_FALLBACKS[simpleSlug]) {
    return BREED_FALLBACKS[simpleSlug];
  }
  return simpleSlug;
}

/**
 * Load a dog breed image with preload and fade.
 * Always keeps a single img element — never adds/removes from DOM on breed change.
 * clearFirst: removes existing image immediately (for dog switch).
 */
window.loadDogImageWithTransition = function (container, imageUrl, altText, clearFirst) {
  if (!container) return;

  var existingImg = container.querySelector('img.quiz-dog-illustration-img');
  if (existingImg && existingImg.src === imageUrl) return;

  // Dog switch: hide old image immediately
  if (clearFirst && existingImg) {
    existingImg.classList.remove('quiz-dog-img-loaded');
    existingImg.remove();
    existingImg = null;
  }

  // Cancel any in-flight preload for this container
  if (container._preloadAbort) {
    container._preloadAbort = true;
  }
  var cancelled = { value: false };
  container._preloadCancel = cancelled;

  // Preload before touching anything
  var preloader = new Image();
  preloader.onload = function () {
    // If a newer call has started, discard this result
    if (container._preloadCancel !== cancelled) return;

    var isVisible = container.offsetParent !== null;

    if (existingImg && isVisible) {
      // Visible breed change: fade out → swap src → fade in
      existingImg.classList.remove('quiz-dog-img-loaded');
      var fallbackTimer = setTimeout(function () {
        existingImg.removeEventListener('transitionend', handler);
        existingImg.src = imageUrl;
        existingImg.alt = altText || '';
        void existingImg.offsetWidth;
        existingImg.classList.add('quiz-dog-img-loaded');
      }, 400);
      function handler() {
        clearTimeout(fallbackTimer);
        existingImg.removeEventListener('transitionend', handler);
        existingImg.src = imageUrl;
        existingImg.alt = altText || '';
        void existingImg.offsetWidth;
        existingImg.classList.add('quiz-dog-img-loaded');
      }
      existingImg.addEventListener('transitionend', handler);
    } else if (existingImg) {
      // Hidden container: instant swap, no transition
      existingImg.src = imageUrl;
      existingImg.alt = altText || '';
    } else {
      // First load or after dog switch: create element, fade in
      var imgEl = document.createElement('img');
      imgEl.src = imageUrl;
      imgEl.alt = altText || '';
      imgEl.className = 'quiz-dog-illustration-img quiz-dog-img-fade';
      imgEl.onerror = function () { this.style.display = 'none'; };
      container.innerHTML = '';
      container.appendChild(imgEl);
      if (isVisible) {
        void imgEl.offsetWidth; // force reflow so browser registers opacity:0
        imgEl.classList.add('quiz-dog-img-loaded');
      } else {
        imgEl.classList.add('quiz-dog-img-loaded');
      }
    }
  };
  preloader.onerror = function () {};
  preloader.src = imageUrl;
};

// Custom select dropdown
function initCustomSelects() {
  var x, i, j, l, ll, selElmnt, a, b, c;
  x = document.getElementsByClassName('custom-select');
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName('select')[0];
    ll = selElmnt.length;

    // Create selected item div (focusable via Tab)
    a = document.createElement('DIV');
    a.setAttribute('class', 'select-selected');
    a.setAttribute('tabindex', '0');
    a.setAttribute('role', 'combobox');
    a.setAttribute('aria-haspopup', 'listbox');
    a.setAttribute('aria-expanded', 'false');
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

    x[i].appendChild(a);

    // Create options container
    b = document.createElement('DIV');
    b.setAttribute('class', 'select-items select-hide');
    b.setAttribute('role', 'listbox');

    var targetContainer = b;

    for (j = 0; j < ll; j++) {
      if (selElmnt.options[j].value === '') continue; // Skip empty options

      c = document.createElement('DIV');
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.setAttribute('data-value', selElmnt.options[j].value);
      c.setAttribute('role', 'option');

      if (j === selElmnt.selectedIndex) {
        c.setAttribute('class', 'same-as-selected');
      }

      c.addEventListener('click', function (e) {
        var y, i, k, s, h, sl, yl;
        var container = this.parentNode;
        s = container.parentNode.getElementsByTagName('select')[0];
        h = container.previousSibling;
        sl = s.length;

        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = container.getElementsByClassName('same-as-selected');
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute('class');
            }
            this.setAttribute('class', 'same-as-selected');
            break;
          }
        }

        // Trigger change event
        var event = new Event('change', { bubbles: true });
        s.dispatchEvent(event);

        h.click();
      });
      targetContainer.appendChild(c);
    }
    x[i].appendChild(b);

    // Click handler for all selects
    a.addEventListener('click', function (e) {
      e.stopPropagation();
      closeAllSelect(this);
      var items = this.nextSibling;
      var opening = items.classList.contains('select-hide');
      items.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
      this.closest('.custom-select').classList.toggle('select-open', opening);
      this.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });

    // Keyboard handler for custom selects
    a.addEventListener('keydown', function (e) {
      var items = this.nextSibling;
      var isOpen = !items.classList.contains('select-hide');
      var options = items.querySelectorAll('[role="option"]');
      if (options.length === 0) return;

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!isOpen) {
          // Open dropdown
          closeAllSelect(this);
          items.classList.remove('select-hide');
          this.classList.add('select-arrow-active');
          this.setAttribute('aria-expanded', 'true');
        } else {
          // Select the highlighted item or close
          var active = items.querySelector('.select-kb-active');
          if (active) {
            active.click();
          } else {
            items.classList.add('select-hide');
            this.classList.remove('select-arrow-active');
            this.setAttribute('aria-expanded', 'false');
          }
        }
      } else if (e.key === 'Escape') {
        if (isOpen) {
          e.preventDefault();
          items.classList.add('select-hide');
          this.classList.remove('select-arrow-active');
          this.setAttribute('aria-expanded', 'false');
        }
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!isOpen) {
          closeAllSelect(this);
          items.classList.remove('select-hide');
          this.classList.add('select-arrow-active');
          this.setAttribute('aria-expanded', 'true');
        }
        // Find current keyboard-active item
        var currentActive = items.querySelector('.select-kb-active');
        var arr = Array.prototype.slice.call(options);
        var idx = currentActive ? arr.indexOf(currentActive) : -1;

        if (e.key === 'ArrowDown') {
          idx = Math.min(idx + 1, arr.length - 1);
        } else {
          idx = Math.max(idx - 1, 0);
        }

        // Update highlight
        for (var k = 0; k < arr.length; k++) {
          arr[k].classList.remove('select-kb-active');
        }
        arr[idx].classList.add('select-kb-active');
        arr[idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Tab') {
        // Close on tab-away, let focus move naturally
        if (isOpen) {
          items.classList.add('select-hide');
          this.classList.remove('select-arrow-active');
          this.setAttribute('aria-expanded', 'false');
        }
      }
    });

    // Clear keyboard highlight when dropdown closes
    a.addEventListener('blur', function () {
      var items = this.nextSibling;
      if (items) {
        var active = items.querySelector('.select-kb-active');
        if (active) active.classList.remove('select-kb-active');
      }
    });
  }
}

function closeAllSelect(elmnt) {
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName('select-items');
  y = document.getElementsByClassName('select-selected');
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove('select-arrow-active');
      y[i].closest('.custom-select').classList.remove('select-open');
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i) === -1) {
      x[i].classList.add('select-hide');
    }
  }
}

document.addEventListener('click', function (e) {
  // Don't close if clicking inside a custom select
  if (!e.target.closest('.custom-select')) {
    closeAllSelect();
  }
});

// Save and restore quiz progress
// Storage logic removed - handled by KismetQuiz in quiz.js

// Handle dog count changes
document.addEventListener('DOMContentLoaded', function () {
  // Initialize custom selects first
  // Initialize custom selects first
  initCustomSelects();

  // restoreQuizData() removed - handled by KismetQuiz

  // Update custom selects to reflect restored values
  setTimeout(function () {
    document.querySelectorAll('.custom-select').forEach(function (customSelect) {
      const select = customSelect.querySelector('select');
      const selectedDiv = customSelect.querySelector('.select-selected');
      if (select && selectedDiv && select.value) {
        selectedDiv.innerHTML = select.options[select.selectedIndex].innerHTML;
      }
    });

    // Trigger update for dog name and breed illustration
    const dogNameInput = document.getElementById('quiz-dog-name-1');
    if (dogNameInput && dogNameInput.value) {
      dogNameInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    const breedSelect = document.getElementById('quiz-dog-breed');
    if (breedSelect && breedSelect.value) {
      breedSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, 100);

  const dogCountSelect = document.getElementById('quiz-dog-count');
  const dogLabel = document.getElementById('dog-label');

  if (dogCountSelect) {
    dogCountSelect.addEventListener('change', function () {
      const count = parseInt(this.value);

      // Update label text
      if (dogLabel) dogLabel.textContent = count === 1 ? 'dog, named' : 'dogs, named';

      // Show/hide dog rows
      for (let i = 1; i <= 3; i++) {
        const row = document.getElementById(`dog-row-${i}`);
        if (row) {
          if (i <= count) {
            row.style.display = 'flex';
          } else {
            row.style.display = 'none';
            // Values are preserved in state by quiz.js
          }
        }
      }
    });
  }

  // Update dog name in Steps 2-7
  const dogNameInput = document.getElementById('quiz-dog-name-1');

  // IDs of elements that should display the dog name
  const dogNameTargetIds = [
    'dog-name-display', 'quiz-dog-title-2',
    'dog-name-display-3', 'quiz-dog-title-3',
    'dog-name-display-4', 'quiz-dog-title-4',
    'dog-name-display-5', 'quiz-dog-title-5',
    'dog-name-display-6', 'quiz-dog-title-6',
    'dog-name-display-7', 'quiz-dog-title-7'
  ];

  function updateDogName() {
    if (!dogNameInput) return;

    const name = dogNameInput.value.trim();

    dogNameTargetIds.forEach(function(id) {
      const element = document.getElementById(id);
      if (element) {
        // Determine default text based on element ID
        let defaultText = 'Your dog';
        
        if (id.indexOf('title') !== -1) {
          defaultText = 'Your Dog';
        } else if (id === 'dog-name-display-6') {
          defaultText = 'your dog';
        }

        element.textContent = name || defaultText;
      }
    });
  }

  if (dogNameInput) {
    dogNameInput.addEventListener('input', function () {
      // Update dog name in real-time as user types
      updateDogName();
      // saveQuizData() removed;
    });
  }

  // Initial update on page load if there's already a name
  updateDogName();

  // Save data listeners removed - handled by KismetQuiz

  // Update dog breed illustration
  const breedSelect = document.getElementById('quiz-dog-breed');
  const step2Divider = document.getElementById('quiz-step2-divider');
  const step2Illustration = document.getElementById('quiz-step2-illustration');

  if (breedSelect) {
    breedSelect.addEventListener('change', function () {
      const breed = this.value;
      if (breed && window.SHOPIFY_CDN_BASE_URL) {
        const breedSlug = getBreedSlug(breed);
        const imageUrl = window.SHOPIFY_CDN_BASE_URL + 'breed_' + breedSlug + '.png';

        // Reveal step 2 illustration side (only animate first time)
        if (step2Divider && step2Divider.classList.contains('quiz-step2-hidden')) {
          step2Divider.classList.remove('quiz-step2-hidden');
          step2Divider.classList.add('quiz-step2-reveal');
        }
        if (step2Illustration && step2Illustration.classList.contains('quiz-step2-hidden')) {
          step2Illustration.classList.remove('quiz-step2-hidden');
          step2Illustration.classList.add('quiz-step2-reveal');
        }

        // Update illustration in all steps with preload + fade-in
        var containers = document.querySelectorAll('.quiz-dog-illustration');
        containers.forEach(function (container) {
          window.loadDogImageWithTransition(container, imageUrl, breed);
        });
      }
    });
  }

  // Update allergies label based on selection
  const allergiesSelect = document.getElementById('quiz-dog-allergies');
  const allergiesLabel = document.getElementById('quiz-allergies-label');
  if (allergiesSelect && allergiesLabel) {
    allergiesSelect.addEventListener('change', function () {
      allergiesLabel.textContent = this.value === 'true' ? 'have an allergy' : 'have any food allergies';
    });
  }

  // Handle size selector clicks
  const sizeOptions = document.querySelectorAll('.quiz-size-option');
  const sizeInput = document.getElementById('quiz-dog-size');

  sizeOptions.forEach(function (option) {
    option.addEventListener('click', function () {
      // Remove selected class from all options
      sizeOptions.forEach((opt) => opt.classList.remove('selected'));

      // Add selected class to clicked option
      this.classList.add('selected');

      // Update hidden input value
      const sizeValue = this.dataset.size;
      if (sizeInput) {
        sizeInput.value = sizeValue;
        // Trigger change event to save data
        sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // Update spayed/neutered text based on gender
  const genderSelect = document.getElementById('quiz-dog-gender');
  const spayedNeuteredText = document.getElementById('spayed-neutered-text');

  function updateSpayedNeuteredText() {
    if (genderSelect && spayedNeuteredText) {
      const gender = genderSelect.value;

      // Only show "spayed" or "neutered" based on gender (the select handles "is/isn't")
      if (gender === 'female') {
        spayedNeuteredText.textContent = 'spayed';
      } else if (gender === 'male') {
        spayedNeuteredText.textContent = 'neutered';
      } else {
        spayedNeuteredText.textContent = 'spayed/neutered';
      }
    }

    // Update dog name in Step 4
    const nameInput = document.getElementById('quiz-dog-name-1');
    const nameDisplay4 = document.getElementById('dog-name-display-4');
    if (nameInput && nameDisplay4) {
      const name = nameInput.value.trim();
      nameDisplay4.textContent = name || 'Your dog';
    }
  }

  if (genderSelect) {
    genderSelect.addEventListener('change', updateSpayedNeuteredText);
  }

  // Initial update
  updateSpayedNeuteredText();

  // Handle support chips
  const supportChips = document.querySelectorAll('.quiz-chip[data-support]');
  const supportInput = document.getElementById('quiz-dog-support');

  supportChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      const support = this.dataset.support;

      // Read current state from input (synced with current dog's data)
      let selectedSupports = supportInput && supportInput.value
        ? supportInput.value.split(',').filter(s => s)
        : [];

      if (support === 'None') {
        // If "None" is clicked, deselect all others and toggle "None"
        if (this.classList.contains('selected')) {
          // Deselect "None"
          this.classList.remove('selected');
          selectedSupports = [];
        } else {
          // Select only "None", deselect all others
          supportChips.forEach((c) => c.classList.remove('selected'));
          this.classList.add('selected');
          selectedSupports = ['None'];
        }
      } else {
        // If any other chip is clicked
        // First, remove "None" if it's selected
        const noneChip = document.querySelector('.quiz-chip[data-support="None"]');
        if (noneChip && noneChip.classList.contains('selected')) {
          noneChip.classList.remove('selected');
          selectedSupports = selectedSupports.filter((s) => s !== 'None');
        }

        // Toggle the clicked chip
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          selectedSupports = selectedSupports.filter((s) => s !== support);
        } else {
          this.classList.add('selected');
          selectedSupports.push(support);
        }
      }

      // Update hidden input
      if (supportInput) {
        supportInput.value = selectedSupports.join(',');
        supportInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // Handle diet chips (single-select, like radio buttons)
  const dietChips = document.querySelectorAll('.quiz-chip[data-diet]');
  const dietInput = document.getElementById('quiz-dog-diet');

  dietChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      const diet = this.dataset.diet;

      // If already selected, deselect it
      if (this.classList.contains('selected')) {
        this.classList.remove('selected');
        if (dietInput) {
          dietInput.value = '';
          dietInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        // Deselect all other chips first (single-select behavior)
        dietChips.forEach(c => c.classList.remove('selected'));
        // Select clicked chip
        this.classList.add('selected');
        // Update hidden input with single value
        if (dietInput) {
          dietInput.value = diet;
          dietInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  // ─── Dog Name Autocomplete ───────────────────────────────────────────
  (function initDogNameAutocomplete() {
    var MAX_SUGGESTIONS = 8;

    // Gather all dog name data once
    function getDogNames() {
      if (window.quizData && window.quizData.dogNames) {
        return window.quizData.dogNames;
      }
      return [];
    }

    // Extract unique sorted name strings
    var _cachedNames = null;
    function getNameList() {
      if (_cachedNames) return _cachedNames;
      var raw = getDogNames();
      var seen = {};
      _cachedNames = [];
      for (var i = 0; i < raw.length; i++) {
        var n = raw[i].name;
        var lower = n.toLowerCase();
        if (!seen[lower]) {
          seen[lower] = true;
          _cachedNames.push(n);
        }
      }
      _cachedNames.sort(function (a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
      return _cachedNames;
    }

    // Filter names: prefix match first, then contains match
    function filterNames(query) {
      if (!query) return [];
      var names = getNameList();
      var q = query.toLowerCase();
      var prefixMatches = [];
      var containsMatches = [];

      for (var i = 0; i < names.length; i++) {
        var nameLower = names[i].toLowerCase();
        if (nameLower === q) continue; // skip exact match (already typed)
        if (nameLower.indexOf(q) === 0) {
          prefixMatches.push(names[i]);
        } else if (nameLower.indexOf(q) > 0) {
          containsMatches.push(names[i]);
        }
      }

      // Prefix matches come first, then contains
      var results = prefixMatches.concat(containsMatches);
      return results.slice(0, MAX_SUGGESTIONS);
    }

    // Highlight the matching portion in a name
    function highlightMatch(name, query) {
      if (!query) return name;
      var idx = name.toLowerCase().indexOf(query.toLowerCase());
      if (idx === -1) return name;
      var before = name.substring(0, idx);
      var match = name.substring(idx, idx + query.length);
      var after = name.substring(idx + query.length);
      return before + '<span class="quiz-ac-match">' + match + '</span>' + after;
    }

    // Show the hint for a matched name
    function showNameHint(dogIndex, name) {
      var hintEl = document.getElementById('quiz-dog-name-hint');
      if (!hintEl) return;
      if (!name) { hintEl.textContent = ''; return; }

      var dogNames = getDogNames();
      var nameLower = name.trim().toLowerCase();
      var found = null;
      for (var i = 0; i < dogNames.length; i++) {
        if (dogNames[i].name.toLowerCase() === nameLower) {
          found = dogNames[i];
          break;
        }
      }
      hintEl.textContent = found ? found.response : '';
    }

    // Setup autocomplete for a single input
    function setupAutocomplete(inputId, listId, dogIndex) {
      var input = document.getElementById(inputId);
      var list = document.getElementById(listId);
      if (!input || !list) return;

      var activeIdx = -1;
      var currentFiltered = [];
      var isOpen = false;

      function open() {
        if (!isOpen && currentFiltered.length > 0) {
          list.classList.add('is-open');
          isOpen = true;
        }
      }

      function close() {
        list.classList.remove('is-open');
        isOpen = false;
        activeIdx = -1;
        clearActive();
      }

      function clearActive() {
        var items = list.querySelectorAll('li');
        for (var i = 0; i < items.length; i++) {
          items[i].classList.remove('is-active');
        }
      }

      function setActive(idx) {
        clearActive();
        var items = list.querySelectorAll('li');
        if (idx >= 0 && idx < items.length) {
          items[idx].classList.add('is-active');
          // Scroll into view
          items[idx].scrollIntoView({ block: 'nearest' });
        }
      }

      function selectItem(name) {
        input.value = name;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        close();
        showNameHint(dogIndex, name);
      }

      function renderList(filtered, query) {
        currentFiltered = filtered;
        list.innerHTML = '';

        if (filtered.length === 0) {
          close();
          return;
        }

        for (var i = 0; i < filtered.length; i++) {
          var li = document.createElement('li');
          li.innerHTML = highlightMatch(filtered[i], query);
          li.setAttribute('data-name', filtered[i]);
          li.setAttribute('data-index', i);

          li.addEventListener('mousedown', function (e) {
            e.preventDefault(); // prevent blur
            selectItem(this.getAttribute('data-name'));
          });

          li.addEventListener('mouseenter', function () {
            activeIdx = parseInt(this.getAttribute('data-index'), 10);
            setActive(activeIdx);
          });

          list.appendChild(li);
        }

        activeIdx = -1;
        open();
      }

      // Input handler
      input.addEventListener('input', function () {
        var val = this.value.trim();
        if (val.length === 0) {
          close();
          showNameHint(dogIndex, '');
          return;
        }

        var filtered = filterNames(val);
        renderList(filtered, val);
        showNameHint(dogIndex, val);
      });

      // Keyboard navigation
      input.addEventListener('keydown', function (e) {
        if (!isOpen) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIdx = Math.min(activeIdx + 1, currentFiltered.length - 1);
          setActive(activeIdx);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIdx = Math.max(activeIdx - 1, 0);
          setActive(activeIdx);
        } else if (e.key === 'Enter') {
          if (activeIdx >= 0 && activeIdx < currentFiltered.length) {
            e.preventDefault();
            selectItem(currentFiltered[activeIdx]);
          } else {
            close();
          }
        } else if (e.key === 'Escape') {
          close();
        } else if (e.key === 'Tab') {
          close();
        }
      });

      // Close on blur (with small delay to allow click on item)
      input.addEventListener('blur', function () {
        setTimeout(function () { close(); }, 150);
      });

      // Reopen on focus if there's text
      input.addEventListener('focus', function () {
        var val = this.value.trim();
        if (val.length > 0) {
          var filtered = filterNames(val);
          renderList(filtered, val);
        }
      });
    }

    // Initialize for all 3 dog name inputs
    setupAutocomplete('quiz-dog-name-1', 'quiz-autocomplete-1', 0);
    setupAutocomplete('quiz-dog-name-2', 'quiz-autocomplete-2', 1);
    setupAutocomplete('quiz-dog-name-3', 'quiz-autocomplete-3', 2);

    // Close all autocompletes when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.quiz-autocomplete-wrap')) {
        var lists = document.querySelectorAll('.quiz-autocomplete-list');
        for (var i = 0; i < lists.length; i++) {
          lists[i].classList.remove('is-open');
        }
      }
    });
  })();
});
